export default {
  "NODE_ENV": 'production',
  tenantId: 519,
  schemaId: 318,
  seminarId:2102082983179610,//会议id
  onlineSeminarId:2104152045620482,//会议id
  instanceId:83688,//会议实例id
  weChatId: 6030, //正式微信
  "api": {
    "gateway": {
      "general": "https://hw-hwyapi.smarket.net.cn",
      "project": "https://hwproject-api.smarket.net.cn",
      "JsonUrl":'https://hwyhw-static.smarket.net.cn'
    },
  },
  url: {
    // 本站地址
    self: 'https://e-campaign.huawei.com/campaign/partner2021-minisite-1',
    // 华为官网url
    home: 'https://e.huawei.com/cn/?ic_medium=hwdc&ic_source=minisite_01CHNHQ215506M&source=stdh_side',
    // 反馈需求url
    feedback: 'https://e.huawei.com/cn/get-price-info?source_website=MDFDSE5IUTE5NTE0NUw=&ic_medium=hwdc&ic_source=minisite_01CHNHQ215506M&source=stdh_side',
    // 产品方案咨询url
    consult: 'https://app.huawei.com/weiknow#/phone',
    // 百度地图会址url
    baiduMap: 'https://www.amap.com/search?id=B02F37TV2J&city=440304&geoobj=114.171059%7C38.690953%7C120.323403%7C41.200437&query_type=IDQ&query=%E6%B7%B1%E5%9C%B3%E4%BC%9A%E5%B1%95%E4%B8%AD%E5%BF%83&zoom=8',
    // 华为官微url
    weibo: 'https://weibo.com/u/7577602333?from=myfollow_all&is_all=1',
    // 联系我们
    contactus: 'https://www.huawei.com/cn/contact-us',
    // 法律声明
    legal: 'https://www.huawei.com/cn/legal',
    // 隐私保护
    privacy: 'https://www.huawei.com/cn/privacy-policy',
    // 参会报名
    signup: 'https://e-campaign.huawei.com/campaign/partner2021/signup/#/',
    // 预约直播
    orderLive: 'https://e-campaign.huawei.com/campaign/partner2021/signup/#/home?meetingType=online',
    // 线上展厅
    onlineHall: 'https://e-campaign.huawei.com/minisite/cn/exhibition/index.html',
    // 资源预定
    resourceOrder: 'https://eventsgo.huawei.com/#/home',
    // 微吼直播地址
    vhall: 'https://live.huawei.com/partner2021/meeting/cn/',
  },
  fileUrl:'https://hwyhw.smarket.net.cn/content/index.php?mappingId=',//图片地址
  //大会议程内容类别id、楼层id
  agendaDicId:253038, //内容分类索引id
  liveCateDicId:271622, //直播分类索引id
  floorDicId:271522,//楼层索引Id

  preheatFloderId: 1049001,//预热赞助商资料
  shareTitle:"因聚而生，有能有为 | 华为中国生态大会2021",
  shareDesc:"因聚而生，有能有为 | 华为中国生态大会2021-邀您相聚深圳",
  shareImgUrl:'https://hwyhw.smarket.net.cn/f/hw/sFile/tenantId519/2021-04-22/image/1619070255164465.jpg',
  shareSite: 'https://e-campaign.huawei.com/campaign/partner2021-minisite-1',
  //合作伙伴minisite
  registerUrl:"https://e-campaign.huawei.com/campaign/partner2020/home",//报名地址
  orderUrl:"https://e-campaign.huawei.com/campaign/partner2020/order",//预约直播地址
  defaultCover:"http://hwuat.smarket.net.cn/content/index.php?mappingId=908d755a52ff9fb1ceedf776c48d195a",
  defaultAvatar:"https://hwuat.smarket.net.cn/content//hw/sFile/tenantId519/2020-01-09/image/1578562931116315.png",
  homeAddressArticleId:116202, //首页大会地址文章
  pastVideo:116192,//首页往期视频
  momentArticleId: 110960,//首页图集小轮播图
  momentCategoryId:101702, // 首页图集大轮播图
  reviewArticleCategory:{
    'partnerArticleCategoryId': 102997, //生态伙伴
    'newsArticleCategoryId':102995, //大会资讯
    'defaultNews':116561,  //默认资讯文章id
    'wonderfulVideo':2104141029192815,//精彩视频(弃用)
    'wonderfulWords':2105160782102894,//大咖观点
    'wonderfulPic':2105163556979230,//精彩图集
    'exhibition':2105050555109940,//展厅导览
    'exhibitionHangye':2105063330050450,//行业馆
    'exhibitionShengtai':2105060159437946,//生态馆
    'exhibitionChanye':2105063385225366,//产业馆
    'guide':102996,//参会指南
  },

  toClue1: "https://e.huawei.com/cn/get-price-info?utm_campaign=ECHN23195103G&utm_medium=ot&utm_source=offline-exhibition&source=shengtaidahui2020", //填写需求
  toClue2: "https://support.huawei.com/livechat/chatClient/chatbox.jsp?companyID=8981&configID=59&live800_ud_sq=sqfw&syslanguage=0&enterurl=https://e-campaign.huawei.com/campaign/ecopartner2020/#/", //在线咨询
  websiteUrl: "https://e.huawei.com/cn/?rs=-&utm_campaign=-&country=CN", //官网地址

  attendGuide:{//参会指南
    'address':102055,//大会地址
    'banche':102057,//班车信息
    'transport':102056,//交通引导
    news:{
      'diningroom':102059,//休闲资讯-餐厅推荐栏目id
    }
  },
  previewUrl:"https://ow365.cn/?i=17400&ssl=1&furl=",
  exhibition: {
    'SamplePoint': 102044, //样板点栏目
    'defaultSamplePoint':102047,//默认样板点
    'pointFolderId': 1054736, //样板点资料文件夹id
    'exhibition': 101973, //展台栏目
    "defaultExhibition":102029,//默认展区
    'exhibitionFolderId': 1054742, //展台资料文件夹id
  },
  files: {
    'files': 102062, //主题演讲
    'filesFolderId': 1054739, //主题演讲文件夹id
    'topic17FolderId': 1022231, //17主题演讲文件夹id
    'topic181FolderId': 1022300, //18-1主题演讲文件夹id
    'topic182FolderId': 1022328, //18-2主题演讲文件夹id
  },

  //直播图片及播放情况控制
  isBannerShow:false,//直播窗口未漏出
  isVideoShow:4,//1:显示直播控件
                //2：跳转分论坛链接，先找一个敬请期待的分论坛，如果在三十分钟内则显示可以点击的kv图，三十分钟外显示不可点击的kv图
                //3:kv图，不可点击。当21日分论坛都结束且主会和分论坛都无点播，则需要放此图
                //4:往期视频
  i_kvVideoUrl: 'https://live.myun.tv/watch/60pzk5.m3u8', //kv上的直播地址
  kvVideoImg: require('../assets/images/index/banner-wap-3q.jpg'),
  pastVideoUrl:'https://vod.mudu.tv/media-join-slice/wm1e6zf05oxxksn6jx1fcap6r.m3u8',//
  pastVideoImg:'https://hwyhw.smarket.net.cn/content/index.php?mappingId=25f232dd63c6f22148f39340acab59dd',//往期视频封面图
  countOpenTime:1800,//会议时间与服务器时间差，默认为30分钟，控制敬请期待情况下可以点击
  pageTitle: '因聚而生，有能有为 | 华为中国生态大会2021',
  pageKeywords: '华为中国生态大会2021、生态大会、生态伙伴大会、生态伙伴',
  pageDescription: '站在数字时代的新起点，我们看到，数字化转型的趋势性价值与机会空间无比广阔，正化作时代的最强光指引千行百业穿越迷雾。迎接更深层的转型新局，我们发现，唯有能力共进、持续深耕、全面协同，才能在众多不确定性的挑战中，创造更多确定性价值！“因聚而生，有能有为”，华为中国生态大会2021，期待与每一位有能力、有抱负的生态伙伴一起，合力相融，能力共进，释放更大生态潜能，在时代新局下共育新机，共赢价值，共享繁荣！2021年5月17日-18日，我们诚邀您相聚深圳，携手共见！',
  wxShareConfigArticleId: 2104223297839282,
  signUpTcCode: 'B7hQGKNybU',
  mainLiveArticleId: 2105111965253178, // 主直播配置
}
